<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <div>
    <CCard>
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Dokumen Persyaratan Asean CPA
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <!-- Data dokumen -->
      <CCardBody>        
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable             
              style="widht:100% !important" 
              :items="items" 
              :fields="fields"
              :tableFilter='{ label:"Pencarian", placeholder:"Cari Data .." }'
              :items-per-page="10"              
              :items-per-page-select='{ label : "Data Per Halaman"}'  
              hover 
              sorter
              :pagination='{ class: "float-right" }'>
              <template #no="{index}">
                <td class="py-2">{{ indexed == 0 ? index+1: index+indexed + 1 }}</td>
              </template>
              <template #namaDokumen="{item}">
                <td class="py-2 text-left">{{item.namaDokumen ? item.namaDokumen : "-" }}</td>
              </template>
              <template #statusWajib="{item}">
                <td 
                  class="font-weight-bold text-left"
                  :class="{
                    'text-success': item.statusWajib == '1',
                    'text-danger': item.statusWajib == '0',
                  }"
                >
                  {{ item.statusWajib == '1' ? 'Wajib' : 'Tidak Wajib' }}
                </td>                   
              </template> 
              <template #status_upload="{item}">
                <td
                  class="font-weight-bold text-secondary"
                  v-if="item.statusUpload == '0'"
                >Belum Upload</td>
                <td
                  class="font-weight-bold text-success"
                  v-if="item.statusUpload ==   '1'"
                >Terverifikasi</td>
                <td
                  class="font-weight-bold text-primary"
                  v-if="item.statusUpload ==   '2'"
                >Sudah Upload</td>
                <td
                  class="font-weight-bold text-info"
                  v-if="item.statusUpload ==      '3'"
                >File Tidak Terbaca</td>
                <td
                  class="font-weight-bold text-danger"
                  v-if="item.statusUpload ==    '4'"
                >File Tidak Sesuai</td>
              </template>
              <template #lihat_file="{item}">                
                <td
                  v-if="item.statusUpload == 1
                  || item.statusUpload == 2 || item.statusUpload == 3 || item.statusUpload == 4"
                >
                  <a
                    style="color:white !important"
                    @click="lihatFile(item)"
                    class="btn btn-sm btn-primary"
                  >File</a>
                </td>
                <td v-else>
                  <button class="btn btn-sm btn-primary" disabled>File</button>
                </td>
              </template>

              <template #aksi="{item, index}">
                <td
                  class="py-2 text-center"
                  v-if="item.statusUpload == 1
                  || item.statusUpload == 2 || item.statusUpload == 3 || item.statusUpload == 4"
                >
                  <CButton
                    class="btn-sm text-white mr-2"
                    square
                    :color="item.file == ''?'info':'warning'"
                    :disabled="item.file == ''"
                    @click="lihatFile(item)"
                    v-c-tooltip="'Lihat File'"
                  >
                    <small><i class="fa fa-eye"  ></i></small>
                  </CButton>
                  <CButton
                    color="info"
                    class="btn-sm text-white"
                    square
                    v-c-tooltip="'Verifikasi'"
                    @click="verifikasiDokumen(item.idDokumenAseanCpa,
                  item.statusUpload,item.tanggal_verifikasi,item.alasan)"
                  >     
                    <small><i class="fa fa-check"  ></i></small>
                  </CButton>&nbsp;&nbsp;
                  <CButton
                    color="danger"
                    class="btn-sm d-none"
                    square
                    v-c-tooltip="'Hapus Data'"
                    @click="deleteData(item, index)"
                  >
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </td>
                <td class="py-2" v-else>
                  <CButton 
                  color="info" 
                  class="btn-sm text-white" 
                  square
                  v-c-tooltip="'Verifikasi'"
                  disabled>
                  <small><i class="fa fa-check"  ></i></small>
                  </CButton>&nbsp;&nbsp;
                  <CButton
                    color="danger"
                    class="btn-sm d-none"
                    square
                    v-c-tooltip="'Hapus Data'"
                    @click="deleteData(item, index)"
                  >
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
        <!-- Modal Tambah -->
        <CModal
          title="Modal title"
          :show.sync="myModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm v-on:submit.prevent="postData">
            <CRow>
              
              <CCol sm="12 mb-4">
                <label for class="font-weight-bold">Status</label>
                <br />
                <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                  <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                  <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                  <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
                </select>            
              </CCol>
              <CCol sm="12" v-if="formData.statusUpload != '1'">
                <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
                <textarea 
                  class="form-control" 
                  name="" 
                  id="" 
                  cols="30" 
                  rows="4" 
                  v-model="formData.alasan" 
                  placeholder="Masukkan alasan">
                </textarea>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Verifikasi Persyaratan Dokumen</h6>
          </template>
          <template #footer>
            <CButton @click="myModal = false" color="danger">Tutup</CButton>
            <CButton @click="postData" type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data BPK -->
    </CCard>
  </div>
</template>
<script>
import AseanCpaService from "../../services/keanggotaan/asean-cpa.service";
import DataKeanggotaanService from "../../services/keanggotaan/data-anggota.service";
import Utils from "../../services/utils.service";
import {Pagination} from "../../mixins/Pagination"

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "namaDokumen",
    label: "Nama Dokumen",
    sorter: true,
    filter: true
  },
  {
    key: "statusWajib",
    label: "Status Dokumen",
    sorter: true,
    filter: false,    
  },
  "status_upload",
 
  {
    key: "aksi",
    _style: "width:11%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [Pagination],
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL_FO_USER+"/",
      items: [],    
      formData: {
        idDokumenPendukungPeserta : "",
        idDokumenAseanCpa: "",
        deskripsi: "",
        file: "",
        statusUpload: "",
        alasan: "",
        updated_at: "",
        tanggal_verifikasi: ""
      },
      fileName: "Choose File...",
      fields,      
      currentPage: 1,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getDataDokumen();
    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true,
          format: "YYYY-MM-DD"
        },
        function(start, end, label) {
          // comment console console.log(
                      
                      
        }
      );
    });
  },
  methods: {
    lihatFile(item) {
      
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+item.file+"/lokasi/data_dokumen_pendukung/bearer/" + token,
        item.file,
        params
      );
    },
    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },
    getDataDokumen() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.$formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;
      AseanCpaService.getDokumenMasterCpa(this.$route.params.id_asean_cpa)
        .then(response => {
          loader.hide();          
          this.items = response.data.data;
        })
        .catch(error => {
          loader.hide();
        });
    },
    verifikasiDokumen(
      idDokumenAseanCpa,
      statusUpload,
      tanggal_verifikasi,
      alasan
    ) {
      this.myModal = true;
      this.formData.idDokumenPendukungPeserta = idDokumenAseanCpa;
      this.formData.statusUpload = statusUpload;
      this.formData.alasan = alasan;
      // this.formData.updated_at = updated_at;
      this.formData.tanggal_verifikasi = tanggal_verifikasi;
      
    },
    postData() {
      
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;
      DataKeanggotaanService.verifikasiDataDokumenAseanCpa(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.modalVerif = false;
          this.alertVerif();
          vm.getDataDokumen();
          loader.hide();
          this.myModal = false;
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
     
    },
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>